import { inject, Pipe, PipeTransform } from '@angular/core';
import { AppConfigService } from 'app/services/app-config.service';

@Pipe({
  name: 'ImageUrlPipe',
  standalone: true
})
export class ImageUrlPipe implements PipeTransform {

    private appConfig = inject(AppConfigService);
  
  transform(value: string | null | undefined): string {
    if (!value) return '';

    if (value.startsWith('http://') || value.startsWith('https://')) {
      return value;
    }
    const base = this.appConfig.imageUrl.replace(/\/$/, '');
    const path = value.startsWith('/') ? value : `/${value}`;
    return `${base}${path}`;
  }
}
